import axiosConfig from "./axiosConfig";

class MembreService {
    async getAll() {
        try {
            const response = await axiosConfig.get("/membres");
            return response.data || [];
        } catch (error) {
            console.error("Error fetching membres:", error);
            return [];
        }
    }

    async getById(id) {
        try {
            const response = await axiosConfig.get(`/membres/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching membre:", error);
            return null;
        }
    }

    async create(formData) {
        try {
            const response = await axiosConfig.post("/membres", formData);
            return response.data;
        } catch (error) {
            console.error("❌ Erreur lors de la création:", error.response?.data || error.message);
            return Promise.reject(error.response?.data || { message: error.message });
        }
    }

    async update(id, formData) {
        try {
            const response = await axiosConfig.put(`/membres/${id}`, formData);
            return response.data;
        } catch (error) {
            console.error("❌ Erreur lors de la mise à jour:", error.response?.data || error.message);
            return Promise.reject(error.response?.data || { message: error.message });
        }
    }

    async delete(id) {
        try {
            const response = await axiosConfig.delete(`/membres/${id}`);
            return response.data;
        } catch (error) {
            console.error("❌ Erreur lors de la suppression:", error.response?.data || error.message);
            return Promise.reject(error.response?.data || { message: error.message });
        }
    }
}

const MembreServiceInstance = new MembreService();
export default MembreServiceInstance;